// Card slider scrollbar integration with theme's SliderComponent
document.addEventListener('DOMContentLoaded', function() {
  
  // Function to initialize sliders
  function initializeSliders() {
    // Find all slider components that have scrollbars
    const sliders = document.querySelectorAll('.card__media-slider');
    
    sliders.forEach(sliderComponent => {
      // Skip if already initialized
      if (sliderComponent.dataset.sliderInitialized) return;
      sliderComponent.dataset.sliderInitialized = 'true';
      
      const scrollbar = sliderComponent.querySelector('.slider-scrollbar-active');
      const slider = sliderComponent.querySelector('.slider');
      
      if (!scrollbar || !slider) return;
          
      function updateScrollbar() {
        const slides = slider.querySelectorAll('.slider__slide');
        const totalSlides = slides.length;
        
        if (totalSlides <= 1) {
          scrollbar.style.display = 'none';
          return;
        }
        
        // Try multiple methods to detect current slide
        let currentSlide = 0;
        
        // Method 1: Check scroll position
        const slideWidth = slider.scrollWidth / totalSlides;
        const scrollBasedSlide = Math.round(slider.scrollLeft / slideWidth);
        
        // Method 2: Check which slide is visible in viewport
        let visibleSlide = 0;
        slides.forEach((slide, index) => {
          const rect = slide.getBoundingClientRect();
          const sliderRect = slider.getBoundingClientRect();
          if (rect.left >= sliderRect.left - 50 && rect.left <= sliderRect.left + 50) {
            visibleSlide = index;
          }
        });
        
        // Method 3: Check theme's current page if available
        if (sliderComponent.currentPage !== undefined) {
          currentSlide = sliderComponent.currentPage - 1; // Theme uses 1-based indexing
        } else {
          currentSlide = Math.max(scrollBasedSlide, visibleSlide);
        }
              
        // Update scrollbar position
        const width = 100 / totalSlides;
        const left = currentSlide * width;
        
        scrollbar.style.width = `${width}%`;
        scrollbar.style.left = `${left}%`;
      }
      
      // Method 1: Listen for scroll events
      slider.addEventListener('scroll', () => {
        updateScrollbar();
      });

      let isDragging = false;
      let dragDistance = 0;
      let startX = 0;
      let scrollStart = 0;
      const CLICK_THRESHOLD = 1;

      slider.addEventListener('mousedown', function(e) {
        isDragging = true;
        dragDistance = 0;
        startX = e.pageX;
        scrollStart = slider.scrollLeft;
        e.preventDefault();
        e.stopPropagation();
      });

      document.addEventListener('mousemove', function(e) {
        if (!isDragging) return;
        if (e.buttons !== 1) return;
        slider.classList.add('is-dragging');
        
        const dx = e.pageX - startX;
        dragDistance = Math.abs(dx);
        
        slider.scrollLeft = scrollStart - (dx * 1.2);
        updateScrollbar();
        e.preventDefault();
        e.stopPropagation();
      });

      document.addEventListener('mouseup', function(e) {
        if (isDragging) {
          isDragging = false;
          slider.classList.remove('is-dragging');
          updateScrollbar();
          e.preventDefault();
        }
      });

      const sliderLinks = document.querySelectorAll('.card__media a');
      sliderLinks.forEach(link => {
        link.addEventListener('click', function(e) {
          if (dragDistance > CLICK_THRESHOLD || slider.classList.contains('is-dragging')) {
            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();
          }
          setTimeout(() => { dragDistance = 0; }, 10);
        }, true);
      });
      
      // Method 2: Hook into theme's update method
      const originalUpdate = sliderComponent.update;
      if (originalUpdate) {
        sliderComponent.update = function() {
          originalUpdate.call(this);
          setTimeout(updateScrollbar, 0);
        };
      }
      
      // Method 3: Listen for custom events that might be fired
      sliderComponent.addEventListener('slider:updated', updateScrollbar);
      sliderComponent.addEventListener('slide:changed', updateScrollbar);
      
      // Method 4: Watch for transform changes on slider
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
            updateScrollbar();
          }
        });
      });
      
      observer.observe(slider, {
        attributes: true,
        attributeFilter: ['style']
      });
      
      // Method 5: Continuous monitoring
      let lastScrollLeft = slider.scrollLeft;
      let lastTransform = getComputedStyle(slider).transform;
      
      function checkForUpdates() {
        const currentScrollLeft = slider.scrollLeft;
        const currentTransform = getComputedStyle(slider).transform;
        
        if (currentScrollLeft !== lastScrollLeft || currentTransform !== lastTransform) {
          lastScrollLeft = currentScrollLeft;
          lastTransform = currentTransform;
          updateScrollbar();
        }
        
        requestAnimationFrame(checkForUpdates);
      }
      requestAnimationFrame(checkForUpdates);
      
      // Method 6: Listen for touch events that might indicate sliding
      let touchStarted = false;
      let touchStartX = 0;
      let touchStartY = 0;
      
      slider.addEventListener('touchstart', (e) => {
        touchStarted = true;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });
      
      slider.addEventListener('touchmove', (e) => {
        if (!touchStarted) return;
        
        const touchX = e.touches[0].clientX;
        const touchY = e.touches[0].clientY;
        const deltaX = Math.abs(touchX - touchStartX);
        const deltaY = Math.abs(touchY - touchStartY);
        
        // If user is scrolling more horizontally than vertically, prevent vertical scroll
        if (deltaX > deltaY && deltaY < 10) {
          // Horizontal scroll is dominant, let it happen
          updateScrollbar();
        }
      }, { passive: true });
      
      slider.addEventListener('touchend', () => {
        if (touchStarted) {
          setTimeout(updateScrollbar, 100);
          touchStarted = false;
        }
      }, { passive: true });
      
      // Initial update
      updateScrollbar();
    });
  }
  
  // Initialize sliders that are already present
  initializeSliders();
  
  // Watch for dynamically loaded content (like related products)
  const observer = new MutationObserver((mutations) => {
    let hasNewSliders = false;
    
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check if the added node contains slider components
            if (node.querySelector && node.querySelector('.card__media-slider')) {
              hasNewSliders = true;
            }
            // Or if the node itself is a slider component
            if (node.classList && node.classList.contains('card__media-slider')) {
              hasNewSliders = true;
            }
          }
        });
      }
    });
    
    if (hasNewSliders) {
      // Delay initialization slightly to ensure DOM is fully updated
      setTimeout(initializeSliders, 50);
    }
  });
  
  // Observe the entire document for new slider components
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});